import { useState } from "react";

export const useFilesToNotSend = () => {
  //selecionar itens que não vão ser enviados
  const [filesToNotSend, setFilesToNotSend] = useState([]);
  const addFileInFilesToNotSend = (fileId) => {
    setFilesToNotSend((prev) => [...prev, fileId]);
  };
  const removeFileFromFilesToNotSend = (id) => {
    setFilesToNotSend((prev) => prev.filter((item) => item !== id));
  };
  const clearFilesToNotSend = () => {
    setFilesToNotSend([]);
  };

  const handleCheckToRemoveFiles = (e, id_conteudo) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      removeFileFromFilesToNotSend(id_conteudo);
    } else {
      addFileInFilesToNotSend(id_conteudo);
    }
  };

  return {
    filesToNotSend,
    clearFilesToNotSend,
    handleCheckToRemoveFiles,
  };
};
